export default "__VITE_ASSET__B7T$xB6D__"